import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaPaperPlane } from "react-icons/fa";
import { contactInfo } from "../../utils/data";
const Contact = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    // Contact Section
    <section className="contact-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={7}>
            <motion.div className="section-header text-center mb-5"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="section-title">Contact Us</h2>
              <p className="section-subtitle section-subtext text-muted">Have questions or need assistance? We're here to help!</p>
            </motion.div>
          </Col>
        </Row>
        <Row className="g-4">
          <Col lg={4}>
            <motion.div className="contact-info"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              {contactInfo.map((item, index) => (
                <motion.a className="contact-info-item"
                  key={index}
                  href={item.link}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <div className="icon-wrapper">{item.icon}</div>
                  <div className="info-content">
                    <h5>{item.title}</h5>
                    <p>{item.info}</p>
                  </div>
                </motion.a>
              ))}
            </motion.div>
          </Col>
          <Col lg={8}>
            <motion.form className="contact-form"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              onSubmit={handleSubmit}
            >
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label className="form-label">Your Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Enter your name" required />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="Enter your email" required />
                  </div>
                </Col>
                <Col md={12}>
                  <div className="form-group">
                    <label className="form-label">Subject</label>
                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="form-control" placeholder="Enter subject" required />
                  </div>
                </Col>
                <Col md={12}>
                  <div className="form-group">
                    <label className="form-label">Message</label>
                    <textarea name="message" value={formData.message} onChange={handleChange} className="form-control" rows="5" placeholder="Write your message..." required />
                  </div>
                </Col>
                <Col md={12}>
                  <motion.button className="btn btn-primary w-100" type="submit"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <FaPaperPlane className="me-2" />
                    Send Message
                  </motion.button>
                </Col>
              </Row>
            </motion.form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default Contact;